import React from 'react';
import preparingPlanImage from '../../../assets/images/bg-preparingPlan.png';

const PreparingPlan = ({ data }) => {
  return (
    <div
      className="flex h-full w-full items-center justify-center text-center"
      style={{
        backgroundColor: '#F4FAFA',
        minHeight: '100%',
      }}
    >
      <div className="flex w-full flex-col items-center px-6 py-6">
        <div
          className="flex items-center justify-center rounded-full bg-white"
          style={{
            width: 300,
            height: 300,
            padding: 18,
          }}
        >
          <img src={preparingPlanImage} alt="Plano em preparação" className="h-full w-full rounded-full object-cover" />
        </div>

        <div
          className="mt-8 rounded-full px-7 py-2"
          style={{
            backgroundColor: '#337BA9',
          }}
        >
          <span className="text-sm font-bold tracking-widest text-white">PLANO EM PREPARAÇÃO</span>
        </div>

        <h1
          className="mt-7 max-w-4xl font-semibold leading-tight"
          style={{
            color: '#337BA9',
            fontSize: 36,
          }}
        >
          Seu plano financeiro está sendo preparado.
          <br />
          Em breve você poderá acessá-lo.
        </h1>

        <p
          className="mt-5 max-w-3xl italic leading-relaxed"
          style={{
            color: '#143145',
            fontSize: 20,
          }}
        >
          Estamos preparando o caminho para o seu próximo passo financeiro.
        </p>
      </div>
    </div>
  );
};

export default PreparingPlan;
